import './georgetown5/style';
import FormStructure from './georgetown5/form_structure';

export default FormStructure;